import React from 'react'
import { Button } from '@next-nx/shared-ui/atoms'
import { MenuItemType } from '@next-nx/utils/types'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils';
import styles from './LandingPreventivoBox.module.sass'


interface Props {
  item?: MenuItemType | undefined
  onClick: () => void
  className?: string
}

const LandingPreventivoBox = (props: Props) => {

  const { 
    item = undefined,
    onClick = undefined,
    className = '',
  } = props

  const { linkDataLayer } = useTealium()

const handleTracking = () => {
  const action_timestamp = getTimestamp()

  linkDataLayer({
     virtual: "action",
     action_name: "richiesta_preventivo", 
     action_tech: "click",
     action_type: "richiedi_preventivo",
     action_timestamp,
     action_effect: "form_richiesta_preventivo_accesso"
  });
}

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.content}>
        <p className={styles.title}>{item.name}</p>
        {item.description && <div className={styles.description} dangerouslySetInnerHTML={{ __html: item.description }} />}
      </div>
      {item.ctaLabel && onClick && (
        <div className={styles.ctaBox}>
          <Button label={item.ctaLabel} onClick={onClick} handleTracking={handleTracking} />
        </div>
      )}
    </div>
  ) : <></>
}

export default LandingPreventivoBox
